import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-green-500 rounded-lg">
              <i className="ri-heart-pulse-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">Liver Health Check</span>
          </button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8 notranslate" translate="no">利用規約</h1>

          <div className="bg-white rounded-2xl p-8 shadow-lg space-y-8 notranslate" translate="no">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第1条（適用）</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                本規約は、MKメディカルパートナーズ（以下「当事業者」といいます）が提供する肝臓の健康セルフチェック・管理プラットフォーム「Liver Health Check」（以下「本サービス」といいます）の利用条件を定めるものです。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第2条（サービスの性質）</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 text-sm text-gray-700 leading-relaxed">
                <li>本サービスは医療行為、診断、治療を行うものではありません。</li>
                <li>本サービスは健康情報の提供を目的としています。</li>
                <li>本サービスの結果は、日本肝臓学会および日本消化器病学会のガイドライン等に基づいた参考情報であり、医療判断の代替となるものではありません。</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第3条（利用者の責任）</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 text-sm text-gray-700 leading-relaxed">
                <li>本サービスの結果に基づく判断は、利用者自身の責任において行うこと。</li>
                <li>体調不良や不安がある場合は、医師・医療機関に相談すること。</li>
                <li>入力するデータの正確性について責任を負うこと。</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第4条（禁止事項）</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 text-sm text-gray-700 leading-relaxed">
                <li>本サービスを医療行為・診断・治療の代替として使用すること。</li>
                <li>虚偽の情報を入力すること。</li>
                <li>本サービスの運営を妨害する行為。</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第5条（免責事項）</h2>
              <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>当事業者は、以下の事項について一切の責任を負いません。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>本サービスの結果の正確性、完全性、有用性。</li>
                  <li>本サービスの利用、または結果に基づく判断により生じた損害。</li>
                  <li>本サービスの中断、停止、終了により生じた損害。</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第6条（規約の変更）</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                当事業者は、必要に応じて本規約を変更することができます。変更後の規約は、本サービス上に掲載した時点で効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">第7条（準拠法・管轄裁判所）</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                本規約の解釈にあたっては日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当事業者の所在地を管轄する裁判所を専属的合意管轄とします。
              </p>
            </section>

            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">制定日：2026 年1月1日</p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              ← トップページへ戻る
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
